import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
    icon: ReactNode;
    label: string;
};

export function GaiaMapLegendRow({ icon, label }: Props) {
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            {icon}
            <Typography variant="body2">{label}</Typography>
        </Stack>
    );
}
